import util from '../lib/util';
import * as DateUtil from '../lib/dateutils';
import newHRTimestamp from '../lib/picos/timestamp';
import type {uuid, SchemaField, EntitySchema} from "../@types/schema";
import Base from "./base";
import {genUUID} from "../lib/picos/uuids";
import type {EntityType} from "../@types/entity";
function getCurrentUserId() { return sessionStorage.getItem('userId'); }
function getCurrentFirmId() { return sessionStorage.getItem('firmId'); }
class TimeOff extends Base implements EntityType {
    timeOffId: uuid;
    userId: uuid;
    requestDate?: Date | null;
    startDate?: Date | null;
    endDate?: Date | null;
    reason: uuid;
    approvedBy?: uuid | null;
    isPaid: boolean;
    constructor(doc: typeof TimeOff | any) {
        super(doc);
        if (!doc) doc = {
            firmId: getCurrentFirmId(),
            addedBy: getCurrentUserId(),
            addedOn: newHRTimestamp(),
            status: "C",
            entityId: null,
            entityType: null,
            timeOffId: genUUID(),
            userId: null,
            reason: null,
        };
        // @ts-ignore
        this.entityId = doc._entityId || doc.entityId || doc.entityid || '00000000-0000-0000-0000-000000000000';
        // @ts-ignore
        this.entityType = doc._entityType || doc.entityType || doc.entitytype || "timeOff";
        // @ts-ignore
        this.timeOffId = doc._timeOffId || doc.timeOffId || doc.timeoffid || genUUID();
        // @ts-ignore
        this.userId = doc._userId || doc.userId || doc.userid || null;
        // @ts-ignore
        this.requestDate = DateUtil.timestampOnly(doc._requestDate) || DateUtil.timestampOnly(doc.requestDate) || DateUtil.timestampOnly(doc.requestdate) || null;
        // @ts-ignore
        this.startDate = DateUtil.timestampOnly(doc._startDate) || DateUtil.timestampOnly(doc.startDate) || DateUtil.timestampOnly(doc.startdate) || null;
        // @ts-ignore
        this.endDate = DateUtil.timestampOnly(doc._endDate) || DateUtil.timestampOnly(doc.endDate) || DateUtil.timestampOnly(doc.enddate) || null;
        // @ts-ignore
        this.reason = doc._reason || doc.reason || null;
        // @ts-ignore
        this.approvedBy = doc._approvedBy || doc.approvedBy || doc.approvedby || null;
        // @ts-ignore
        this.isPaid = util.defaultBoolean([doc.isPaid, doc._isPaid, doc.ispaid, false]);
    }
    get id(): uuid { return this.timeOffId; }
    static override getPkFields(): SchemaField[] { return [{"type":"uuid","required":true,"pk":true,"default":"__UUID__","comment":"Unique ID for a timeOff"},{"type":"uuid","required":true,"pk":true,"base":true,"default":"__FIRM__","comment":"Associated firm"}]; }
    toLowerCase() { return this.timeOffId; }
    static override getNonRefArrayFields(): string[] { return []; }
    static override getDefaultEntries(): TimeOff[] {
        return [];
    }
    static override getSchema(): EntitySchema {
        return Base.withBaseFields({
    entity: 'timeOff',
    dataArea: 'Staff',
    table: 'TIME_OFF',
    comment: 'A time-off request record for a firm staff member, covering a date range with a reason (e.g., Vacation, Sick Leave, Family Illness) and whether it is paid leave. Time-off records are used for HR tracking and are factored into deadline calculations as firm holidays when the reason matches a holiday category.',
    fields: {
        timeOffId: {
            type: 'uuid', required: true, pk: true, default: '__UUID__', comment: 'Unique ID for a timeOff'
        },
        
        userId: {
            type: 'uuid', entityType: 'user', deleteStrategy: 'preserve', required: true, comment: 'The user with the timeOff period'
        },

        requestDate: {
            type: 'timestamp', comment: 'Date that the request was made'
        },

        startDate: {
            type: 'timestamp', comment: 'Date that the timeOff starts'
        },

        endDate: {
            type: 'timestamp', comment: 'Date that the timeOff ends'
        },

        /**
         * A lookup for a reason, such as:
         * - Vacation
         * - Sick day
         */
        reason: {
            type: 'uuid',
            entityType: 'lookup',
            lookupPaths: ['timeoff:reasons'],
            required: true,
            comment: 'Time Off reason'
        },

        approvedBy: {
            type: 'uuid', entityType: 'user', comment: 'Who approved the time off?'
        },

        isPaid: {
            type: 'boolean', comment: 'Is this paid time off?'
        }
    },
    maps: [
        {name: 'userId', keysFn: t => t.userId, presentFn: (t, k) => t.userId === k},
        {name: 'reason', keysFn: t => t.reason, presentFn: (t, k) => t.reason === k},
        {name: 'approvedBy', keysFn: t => t.approvedBy, presentFn: (t, k) => t.approvedBy === k},
    ]
});
    }
}
export default TimeOff;
